import { render, staticRenderFns } from "./AddEdit.vue?vue&type=template&id=1b4c1216"
import script from "./AddEdit.vue?vue&type=script&lang=js"
export * from "./AddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports